import React from 'react';
import PropTypes from 'prop-types';
export const AttachIcon = props => (
	<svg xmlns='http://www.w3.org/2000/svg' width={props.width} height={props.height} viewBox='0 0 25 24' fill='none'>
		<g>
			<path
				d='M18.6394 21.6197C17.7594 21.8797 16.7194 21.9997 15.4994 21.9997H9.49937C8.27937 21.9997 7.23937 21.8797 6.35938 21.6197C6.57937 19.0197 9.24937 16.9697 12.4994 16.9697C15.7494 16.9697 18.4194 19.0197 18.6394 21.6197Z'
				stroke={props.color}
				strokeWidth='1.5'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M15.5 2H9.5C4.5 2 2.5 4 2.5 9V15C2.5 18.78 3.64 20.85 6.36 21.62C6.58 19.02 9.25 16.97 12.5 16.97C15.75 16.97 18.42 19.02 18.64 21.62C21.36 20.85 22.5 18.78 22.5 15V9C22.5 4 20.5 2 15.5 2ZM12.5 14.17C10.52 14.17 8.92 12.56 8.92 10.58C8.92 8.6 10.52 7 12.5 7C14.48 7 16.08 8.6 16.08 10.58C16.08 12.56 14.48 14.17 12.5 14.17Z'
				stroke={props.color}
				strokeWidth='1.5'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M16.0819 10.58C16.0819 12.56 14.4819 14.17 12.5019 14.17C10.5219 14.17 8.92188 12.56 8.92188 10.58C8.92188 8.6 10.5219 7 12.5019 7C14.4819 7 16.0819 8.6 16.0819 10.58Z'
				stroke={props.color}
				strokeWidth='1.5'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</g>
	</svg>
);

AttachIcon.propTypes={
	width:PropTypes.any,
	height:PropTypes.any,
	color:PropTypes.any
};
